export const SET_COMMITMENT_GROUPS = 'SET_COMMITMENT_GROUPS';
export const SET_IS_LOADING_STATE = 'SET_IS_LOADING_STATE';
export const SET_IS_DOWNLOADING_STATE = 'SET_IS_DOWNLOADING_STATE';
export const SET_SELECTED_PARTNER = 'SET_SELECTED_PARTNER';
export const SET_BID_DUE_DATE_GROUPS = 'SET_BID_DUE_DATE_GROUPS';
export const SET_TABLE_OPTIONS_OBJECT = 'SET_TABLE_OPTIONS_OBJECT';
